import React from 'react';
import { compose, pure } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import LinkOffIcon from '@material-ui/icons/LinkOff';

const styles = {
  leftIcon: {
    padding: '0px 5px'
  }
};

const enhance = compose(pure);

const button = enhance(
  ({ classes, onClickAction, onClickParams, disabled = false }) => {
    return (
      <Button
        color="secondary"
        onClick={() => onClickAction(onClickParams)}
        disabled={disabled}
      >
        <LinkOffIcon className={classes.leftIcon} />
        店舗紐付け解除
      </Button>
    );
  }
);

export default withStyles(styles)(button);
